import {
  UpdateSheetAgentRunTaskDocument,
  UpdateSheetAgentRunTaskMutation,
  UpdateSheetAgentRunTaskMutationVariables,
} from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";

/**
 * Custom hook for updating a sheet agent run task.
 * @returns {Object} - Contains the updateSheetAgentRunTaskMutation function, loading state, and error state.
 */
export default function useUpdateSheetAgentRunTaskMutationHook(): {
  updateSheetAgentRunTaskMutation: any;
  loading: any;
  error: any;
  } {
  const [updateSheetAgentRunTaskMutation, { loading, error }] = useMutation<
    UpdateSheetAgentRunTaskMutation,
    UpdateSheetAgentRunTaskMutationVariables
  >(UpdateSheetAgentRunTaskDocument);

  return {
    updateSheetAgentRunTaskMutation,
    loading,
    error,
  };
}
